<script setup lang="ts">

import VueDatePicker from "@vuepic/vue-datepicker";
import {ref, watch} from "vue";
import UploadModal from "../components/Modals/UploadModal.vue";
import {dateRange, getFinancialData} from "../composables/getFinancial";
import {useAuth} from "../composables/useAuth";

const props = defineProps({
  goBack: {
    type: Function,
    required: true,
  },
  hasPrev: {
    type: Boolean,
    default: false,
  },
  isTopBv: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
});

const handleExport = () => {

}
const handleImport = () => {
  showModal.value = true;
}
const calculateLastWeek = () => {
  const now = new Date();
  const lastWeekStart = new Date(now.setDate(now.getDate() - now.getDay() - 6));
  const lastWeekEnd = new Date(now.setDate(now.getDate() + 6));

  const options = {year: 'numeric', day: 'numeric', month: 'short'};
  const startMonth = lastWeekStart.toLocaleDateString('en-US', options);
  const endMonth = lastWeekEnd.toLocaleDateString('en-US', options);

  if (startMonth === endMonth) {
    return startMonth;
  } else {
    return `${startMonth} - ${endMonth}`;
  }
};
const calculateCurrentMonth = () => {
  const now = new Date(dateRange.value);
  const options = {year: 'numeric', month: 'short'};
  return now.toLocaleDateString('en-US', options);
};
let dateTitle = calculateCurrentMonth();
const week = ref(true);
const dateFormatter = (date: any): string => {
  if (date != null) {
    if (Array.isArray(date)) {
      const options = {year: 'numeric', month: 'short', day: 'numeric'};
      let date1 = new Date(date[0]);
      let response = date1.toLocaleDateString('en-US', options)
      console.log(date[0])
      console.log(date[1])
      if (date[1] != null) {
        let date2 = new Date(date[1]);
        let newResponse = date2.toLocaleDateString('en-US', options);
        if (newResponse != response) {
          response = `${response} - ${newResponse}`;
        }
      }
      return response;
    } else {
      console.log(date)
      const options = {year: 'numeric', month: 'short', day: 'numeric'};
      console.log(new Date(date).toLocaleDateString('en-US', options))
      return new Date(date).toLocaleDateString('en-US', options);
    }
  } else {
    return '';
  }
}
let auth = useAuth()
watch(dateRange, (value) => {
  console.log("dateRangeLocal value changed")
  if (value != null) {
    dateTitle = dateFormatter(dateRange.value);
  }
});
const ChangeDuration = (weekValue: boolean) => {
  week.value = weekValue;
  if (weekValue) {
    dateTitle = calculateLastWeek();
  } else {
    dateTitle = calculateCurrentMonth();
  }
}
const handleFileUpload = (file: File) => {
  showModal.value = false;
  // Handle the uploaded file data here
};
const showModal = ref(false);
const datePickerRef = ref(null);
const showDateRange = ref(false)
const showDatePicker = () => {

  showDateRange.value = true
  if (datePickerRef.value) {
    datePickerRef.value.toggleMenu();
  }
  /*showDateRange.value = !showDateRange.value
  if (!showDateRange.value) {
    if (week.value) {
      dateTitle = calculateLastWeek();
    } else {
      dateTitle = calculateCurrentMonth();
    }
  }*/
};
</script>

<template>
  <header>
    <div class="dashboard-container">
      <div class="flex-row d-flex" @click="goBack()">
        <img
            v-if="hasPrev"
            loading="lazy"
            src="/assets/prev.svg"
            class="icon"
            alt=""
        />
        <h1 :class="hasPrev?'business-name':'dashboard-title'">{{ title }}</h1>
        <span v-if="isTopBv" class="ml-4 status-badge">Top BV</span>
      </div>
      <div class="date-filter-wrapper">
        <span class="date-range">{{ dateTitle }}</span>
        <!--        <div v-if="!showDateRange" class="time-selector" role="group" aria-label="Time period selection">
                  <button @click="ChangeDuration(true)" class="time-option" :class="!week?'':'active'" tabindex="0">Laatste week
                  </button>
                  <button @click="ChangeDuration(false)" class="time-option" :class="week?'':'active'" tabindex="0">Afgelopen
                    maand
                  </button>
                </div>-->

        <VueDatePicker
            v-model="dateRange"
            :monthPicker="true"
            :enable-time-picker="false"
            :uid="title"
            :teleport="true"
            :auto-apply="true"
            :hide-input="true"
            ref="datePickerRef"
        >
          <template #trigger>
            <button class="filter-button" aria-label="Additional filters" >
              <img
                  loading="lazy"
                  src="/assets/calendar.svg"
                  class="filter-icon"
                  alt=""
              />
            </button>
          </template>

        </VueDatePicker>
        <!--        <button
                    class="export-button"
                    tabindex="0"
                    @click="handleExport"
                    type="button"
                >
                  <img
                      loading="lazy"
                      src="/assets/export.svg"
                      class="export-icon"
                      alt=""
                  />
                  <span class="export-text">Exporteren</span>
                </button>-->
        <button
            v-if="auth.canUpload()"
            class="export-button"
            tabindex="0"
            @click="handleImport"
            type="button"
        >
          <img
              loading="lazy"
              src="/assets/export.svg"
              class="export-icon"
              alt=""
          />
          <span class="export-text">Importeren</span>
        </button>
        <UploadModal v-if="showModal" @close="showModal = false" @fileUploaded="handleFileUpload">
        </UploadModal>
      </div>
    </div>
  </header>
</template>

<style scoped>

.export-button {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Primary-Primary, #080aed);
  display: flex;
  min-height: 32px;
  gap: 8px;
  color: var(--Primary-Primary, #080aed);
  white-space: nowrap;
  margin: auto 0;
  padding: 4px 8px;
  font: 600 14px/24px Montserrat, sans-serif;
  background: transparent;
  cursor: pointer;
  width: 130px;
}

.export-button:focus {
  outline: 2px solid var(--Primary-Primary, #080aed);
  outline-offset: 2px;
}

.export-icon {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 24px;
  flex-shrink: 0;
}

.export-text {
  flex-grow: 0;
}

@media (max-width: 991px) {
  .export-button {
    white-space: initial;
  }
}

.filter-icon {
  aspect-ratio: 1;
  width: 24px;
}

.business-name {
  color: var(--Neutral-5, #191a1f);
  font: 500 20px Montserrat, sans-serif;
  margin: 0;
}

.status-badge {
  border-radius: 24px;
  background: var(--Primary-light-1, #c9dafd);
  color: var(--Primary-Primary, #080aed);
  padding: 4px 8px;
  font: 600 10px/1.6 Montserrat, sans-serif;
}

.dashboard-container {
  display: flex;
  margin-top: 16px;
  width: 100%;
  align-items: center;
  gap: 40px 100px;
  justify-content: space-between;
  flex-wrap: wrap;
}

@media (max-width: 991px) {
  .dashboard-container {
    max-width: 100%;
  }
}

.time-option {
  border: none;
  background: none;
  color: var(--Neutral-8, #595c69);
  padding: 4px 16px;
  border-radius: 6px;
  font: 500 12px/1 Montserrat, sans-serif;
  cursor: pointer;
}

.time-option.active {
  background: var(--Neutral-background, #f7f8fc);
  color: var(--Neutral-5, #191a1f);
}

.dashboard-title {
  color: var(--Neutral-5, #191a1f);
  align-self: stretch;
  margin: auto 0;
  font: 700 28px Montserrat, sans-serif;
}

.date-filter-wrapper {
  align-self: stretch;
  display: flex;
  min-width: 240px;
  align-items: center;
  gap: 8px;
  justify-content: start;
  margin: auto 0;
}

.date-range {
  min-width: 200px;
  color: var(--Neutral-5, #191a1f);
  align-self: stretch;
  text-align: end;
  margin: auto 0;
  font: 400 14px Montserrat, sans-serif;
}

.time-selector {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--Neutral-6, #c7c8cc);
  align-self: stretch;
  display: flex;
  gap: 8px;
  width: 260px;
  margin: auto 0;
  padding: 4px;
  font: 500 12px Montserrat, sans-serif;
}

.filter-button {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-7, #787a87);
  align-self: stretch;
  display: flex;
  width: 32px;
  height: 32px;
  margin: auto 0;
  padding: 4px;
}

.filter-icon {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 24px;
  align-self: stretch;
  margin: auto 0;
}

.dashboard-title {
  color: var(--Neutral-5, #191a1f);
  font: 700 28px Montserrat, sans-serif;
  margin-top: 16px;
}

.filter-button {
  border-radius: 8px;
  background: var(--Neutral-6, #ffffff);
  padding: 4px;
  font: 500 12px/1 Montserrat, sans-serif;
}

@media (max-width: 991px) {
  .date-filter-wrapper {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
}
</style>
